import { createReducer } from '@reduxjs/toolkit';

import { Nullable } from 'modules/types/common';
import { createFetchReducer } from 'store/setLocalStore';
import * as actions from './actions';
import { MyDoctorsDto } from './types';

const myDoctorsReducer = createFetchReducer<MyDoctorsDto[]>(actions.GET_MY_DOCTORS, false);
export interface PreferredDoctorState {
  isFetching: boolean;
  error: Nullable<Error>;
}

export const preferenceInitialState: PreferredDoctorState = {
  isFetching: false,
  error: null
};

export const preference = createReducer(preferenceInitialState, {
  [actions.UPDATE_PREFERRED_DOCTORS]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.UPDATE_PREFERRED_DOCTORS_SUCCESS]: (state, action) => {
    state.isFetching = false;
    // Ignore response and re-fetch my doctors
  },
  [actions.UPDATE_PREFERRED_DOCTORS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  }
});

export default myDoctorsReducer;
